<template>
  <div>
    <Title
      v-if="!isAdmin"
      :showMinister="true"
      :showService="true"
    />

    <Breadcrumb :links="breadCrumbData" />

    <Carrusel />

    <div v-if="dataaaa && items && items.length>0" class="container">
      <h3 class="text-indicator">Indicadores de Desempeño año 2017-2020</h3>
      <h5 class="text-indicator">Cuadro 6</h5>
      <h5 class="text-indicator">
        RESULTADO GLOBAL AÑO 2020: {{ items[0].logroFinal }}%
      </h5>
      
      <div
        v-for="(item, items) in items"
        :key="items"
      >
      <hr>
        <h5>
          Indicador:
          <span>{{ item.nombreIndicador }}</span>
        </h5>
        
        <h5>
          Producto Estratégico:
          <span v-html="procesarTextoPE(item.productoEstrategico)"></span>
        </h5>

        <h5>
          Fórmula de cálculo:
          <span>{{ item.formula }}</span>
        </h5>

        <table class=" table table-striped">
          <thead>
            <tr>
              <th scope="col">Variables</th>
              <th scope="col">{{ anio - 3 }}</th>
              <th scope="col">{{ anio - 2 }}</th>
              <th scope="col">{{ anio - 1 }}</th>
              <th scope="col">{{ anio }}</th>
              <th scope="col">Meta {{ anio }}</th>
              <th scope="col">% de Logro {{ anio }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tr">
              <td>Valor Efectivo</td>
              <td style = "white-space: nowrap">
                {{ formattedNumber(item["vEfectivoT-3"])
                }}<span class="data" v-if="item.unidad === '%'">{{
                  item.unidad
                }}</span>
              </td>
              <td style = "white-space: nowrap">
                {{ formattedNumber(item["vEfectivoT-2"]) }}
                <span class="data" v-if="item.unidad === '%'">{{
                  item.unidad
                }}</span>
              </td>
              <td style = "white-space: nowrap">
                {{ formattedNumber(item["vEfectivoT-1"]) }}
                <span class="data" v-if="item.unidad === '%'">{{
                  item.unidad
                }}</span>
              </td>
              <td style = "white-space: nowrap">
                {{ formattedNumber(item.vEfectivoT) }}
                <span class="data" v-if="item.unidad === '%'">{{
                  item.unidad
                }}</span>
              </td>
              <td style = "white-space: nowrap">
                {{ formattedNumber(item.vMeta) }}
                <span class="data" v-if="item.unidad === '%'">{{
                  item.unidad
                }}</span>
              </td>
              <td rowspan="3">{{ formattedNumber(item.logro) }}%</td>
            </tr>

            <tr class="tr">
              <td>
                {{ get_numerador(item.formula) }}</td>

              <td>
                {{ formattedNumber(get_numerador(item.formulaTexto_E3)) }}
              </td>
              <td>
                {{ formattedNumber(get_numerador(item.formulaTexto_E2)) }}
              </td>
              <td>
                {{ formattedNumber(get_numerador(item.formulaTexto_E1)) }}
              </td>
              <td>
                {{ formattedNumber(get_numerador(item.formulaTexto_EF)) }}
              </td>
              <td>
                {{ formattedNumber(get_numerador(item.formulaTexto_ME)) }}
              </td>
            </tr>

            <tr class="tr">
              <td>{{ get_denominador(item.formula) }}</td>
              <td>
                {{ formattedNumber(get_denominador(item.formulaTexto_E3)) }}
              </td>
              <td>
                {{ formattedNumber(get_denominador(item.formulaTexto_E2)) }}
              </td>
              <td>{{ formattedNumber(get_denominador(item.formulaTexto_E1)) }}</td>
              <td>{{ formattedNumber(get_denominador(item.formulaTexto_EF)) }}</td>
              <td>{{ formattedNumber(get_denominador(item.formulaTexto_ME)) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else>
      <NoData />
    </div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import { showAlert } from "../../../components/tools/utils";
// import AlertError from "../../../components/error/AlertError.vue";
import NoData from "./NoData.vue";

import { mapState } from "vuex";
import axios from "axios";

export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    NoData,
    // AlertError,
  },

  data() {
    return {
      breadCrumbData: null,
      listData: [],
      permiso: false,
      items: [],
      anio: `${process.env.VUE_APP_ANIO}`,
      dataaaa: false,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function () {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    formattedNumber: function(value) {
      return new Intl.NumberFormat("de-DE").format(value);
    },

    limpiar(valor){
      if(!valor){return valor}
      valor = valor.trim()
      valor = valor.replace("//","/")
      valor = valor.replace("y/o","y---o")
      valor = valor.replace("(respuestas 5, 6 y 7 en escala 1 a 7)","(respuestas 5, 6 y 7 en escala 1 a 7))")
      valor = valor.replace("* por cada 10.000 Cédulas de Identidad terminadas en año t","")
      valor = valor.replace(")*10000.00",")")
      

      if(valor.indexOf(")*100")>=0 && valor.slice(0,3)==='(1-')
      {
        valor = valor.slice(3,valor.length-5)
      }

      if(valor.indexOf(")*100")>=0 && valor[0]==='(')
      {
        valor = valor.slice(1,valor.length-5)
      }


      if(valor[valor.length-1]===')' && valor[0]==='(')
      {
        valor = valor.slice(1,valor.length-1)
      }

      return valor
    },


    volver_a_poner_caracteres(valor){
      valor = valor.trim()
      if (valor.indexOf(".00")>0 &&  valor.indexOf(".00") === valor.length-3)
      {
        
        valor = valor.slice(0,valor.length-3)
      }

      valor = valor.replace("y---o","y/o")

      if(valor[valor.length-1]===']' && valor[0]==='[')
      {
        valor = valor.slice(1,valor.length-1)
      }

      return valor
    },

    get_numerador(valor){
      if (valor==='Nan'){return "-"}
      

      try{
        valor = this.limpiar(valor)
        valor = this.volver_a_poner_caracteres(valor.split("/")[0])
        return valor
      } catch (error) {
        console.log(error);
        }
      },

      get_denominador(valor){
        if (valor==='Nan'){return "-"}
      
      try{
        // debugger
        console.log(valor)

        valor = this.limpiar(valor)
        console.log(valor)
        valor = this.volver_a_poner_caracteres(valor.split("/")[1])
        return valor
      } catch (error) {
        console.log(error);
        }
    },

    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 4) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4
      ) {
        this.permiso = true;
      }
    },

    setBreadcrumbData: function () {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Indicadores",
          routeName: "indicador",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },

    obtenerContenido: async function () {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=4&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (res.data[0].datos.modificado === undefined) {
          return (this.dataaaa = false);
        }
        var anio = process.env.VUE_APP_ANIO;
        console.log(anio);

        const data = res.data[0].datos;
        this.listData = data.modificado[`${process.env.VUE_APP_ANIO}`];
        this.items = this.listData
        this.dataaaa = true;

      } catch (error) {
        console.log(error);
      }
    },
    procesarUnidad(texto){

      if(texto ==='número')
      {
        return null
      }
      return texto
    },
    procesarTextoPE(texto){
      if (texto.indexOf("\n")>=0)
      {
        // debugger
      }
      texto = "<br>"+texto
      texto = texto.replaceAll("\n","<br>")
      return texto

    },
  },
  mounted() {
    showAlert({
      icon: "success",
      text: "Cargando los datos, espere un momento",
      timerProgressBar: true,
      timer: 4000,
    });
    this.setBreadcrumbData();
    this.obtenerContenido();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>

<style scoped>
.text-indicator {
  text-align: center;
  font-weight: bold;
}

.container {
  margin-top: 20px;
}

th {
  text-align: center !important;
  font-size: 14px !important ;
}

td {
  text-align: left;
}

table {
  margin-bottom: 20px;
}

.col-Left {
  color: #052333;
  font-weight: bold;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 92%;
  padding: 5px;
  text-align: left !important;
  font-size: 13px;
}
h5 {
  color: #052333;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: 10px;
}

span {
  font-weight: 400;
  margin-left: 5px;
}

.div-span-table {
  position: relative;
  top: 32px;
}
</style>
